import { activeSiteConfig } from "@config/site/site-config";

export const hasNotifySizeAvailability = activeSiteConfig?.hasNotifySizeAvailability ?? false;
